// Unversioned list of api objects.  Add versioning storage and lookup upon the first occurance of a versioned api object
let _hostApiObjects = new Map();
export async function tryGetHostApi(apiName, minVersion, targetVersion) {
    var _a;
    if (window) {
        const apiVersionName = apiName + ":" + minVersion;
        const webview = await ((_a = window.chrome) === null || _a === void 0 ? void 0 : _a.webview);
        if (webview) {
            if (_hostApiObjects.has(apiVersionName)) {
                return _hostApiObjects.get(apiVersionName);
            }
            else {
                let apiObject = await webview.hostObjects.hostApi.tryGetApi(apiName, minVersion, targetVersion);
                if (apiObject) {
                    _hostApiObjects.set(apiVersionName, apiObject);
                    return apiObject;
                }
            }
        }
        else if (_hostApiObjects.has(apiName)) {
            // it's a mock, return it
            return _hostApiObjects.get(apiName);
        }
    }
    return null;
}
// Only use this for mocking host api
export function setHostApi(apiName, apiObject) {
    if (apiObject) {
        _hostApiObjects.set(apiName, apiObject);
    }
    else {
        _hostApiObjects.delete(apiName);
    }
}
